import { useMemo } from 'react';

import { useResponsive } from '@garnish/core';

import { useHeaderButtonOptions } from '../../../../../components/Header';
import { NavbarV2 } from '../../../../../components/NavbarV2';
import { defaultHeaderLeft } from '../../../../components/DefaultHeaderLeft';
import {
  CONTENT_WITH_BG_COLOR_STYLES,
  SCREEN_HEADER_OPTIONS,
  STATIC_WITH_BORDER_NAVBAR_SCREEN_OPTIONS,
  type ScreenOptions,
  type ScreenOptionsMap,
} from '../../../../constants';
import { useRouteTitles } from '../../../messages';
import { useModalsPresentation } from '../../../useModalsPresentation';

// ─────────────────────────────────────────────────────────────────────────────

export const useAuthStackOptions = () => {
  const { match } = useResponsive();
  const modalsPresentation = useModalsPresentation();

  const titles = useRouteTitles();
  const { headerLeftOptions } = useHeaderButtonOptions({ headerLeft: defaultHeaderLeft });

  // ─────────────────────────────────────────────────────────────────────

  const stackOptions = useMemo(() => {
    return {
      ...SCREEN_HEADER_OPTIONS,
      ...headerLeftOptions,
      headerShown: true,
      header: match([undefined, renderNavbarV2]),
      presentation: modalsPresentation,
      contentStyle: CONTENT_WITH_BG_COLOR_STYLES,
    } satisfies ScreenOptions;
  }, [headerLeftOptions, match, modalsPresentation]);

  // ─────────────────────────────────────────────────────────────────────

  return useMemo(() => {
    return {
      //
      // ─── Main Stack Options (applied to all screens) ─────────────────────

      Stack: stackOptions,

      // ─── Individual Screen Options ───────────────────────────────────────

      JoinOrSignIn: {
        ...STATIC_WITH_BORDER_NAVBAR_SCREEN_OPTIONS,
        headerShown: match([false, true]),
        customDocumentTitle: titles.joinOrSignInCustomDocumentTitle,
      },
    } satisfies ScreenOptionsMap;
  }, [match, stackOptions, titles]);
};

// ─── Helpers ─────────────────────────────────────────────────────────────────

function renderNavbarV2() {
  return <NavbarV2 />;
}
